export default __webpack_public_path__ + "media/e92707e97a596bb0c5d45d56d74af7c4.png";